import { useCallback, useEffect, useRef } from "react";

export default function useIntersectionObserver(
  ref: React.MutableRefObject<HTMLDivElement | null>,
  callback: (
    entry: IntersectionObserverEntry,
    observer: IntersectionObserver
  ) => void,
  option?: IntersectionObserverInit
) {
  const observer = useRef(
    new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        callback(entry, observer);
      });
    }, option)
  );

  const observe = useCallback((element: HTMLDivElement) => {
    observer.current.observe(element);
  }, []);

  const unobserve = useCallback((element: HTMLDivElement) => {
    observer.current.unobserve(element);
  }, []);

  useEffect(() => {
    const target = ref.current;

    if (target) {
      observe(target);
    }

    return () => {
      if (target) unobserve(target);
    };
  }, [ref, observe, unobserve]);

  return [observe, unobserve];
}
